import { apiSlice } from '../../api/apiSlice';

export const rookBlueprintApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRookBlueprintUrl: builder.mutation({
      query: () => ({
        url: 'RookBlueprint/RookBlueprintUrl',
        method: 'GET',
        credentials: 'include'
      })
    }),
    checkBackToBlueprintEnabled: builder.mutation({
      query: () => ({
        url: 'RookBlueprint/BackToBlueprintEnabled',
        method: 'GET',
        credentials: 'include'
      })
    })
  })
});

export const {
  useGetRookBlueprintUrlMutation,
  useCheckBackToBlueprintEnabledMutation
} = rookBlueprintApi;